import { render, staticRenderFns } from "./bar_chart_widget.vue?vue&type=template&id=e60dd868&"
import script from "./bar_chart_widget.vue?vue&type=script&lang=js&"
export * from "./bar_chart_widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports